import { UserType } from "@/constants";

export type LinkedLicenseDetailsTarget = {
  to: string;
  params?: { licenseId: string };
  search?: { licenseId?: string; tab?: string; openLicense?: string };
};

export function getLinkedLicenseDetailsTarget(
  userType: UserType,
  pathname: string,
  licenseId: string,
): LinkedLicenseDetailsTarget {
  if (userType === UserType.REGISTRANT) {
    if (pathname.includes("/registrant/licenses/")) {
      return {
        to: "/registrant/licenses/$licenseId/view",
        params: { licenseId },
      };
    }
    return {
      to: "/registrant/dashboard",
      search: { openLicense: licenseId },
    };
  }

  const portal = userType === UserType.GOVERNMENT ? "government" : "operator";
  if (pathname.includes("inactive-registrations")) {
    return {
      to: `/${portal}/inactive-registrations`,
      search: { licenseId },
    };
  }
  return {
    to: `/${portal}/registrations`,
    search: { licenseId, tab: "registrations" },
  };
}
